import { render, staticRenderFns } from "./Creditcard.vue?vue&type=template&id=648c0c3c&scoped=true"
import script from "./Creditcard.vue?vue&type=script&lang=js"
export * from "./Creditcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c0c3c",
  null
  
)

export default component.exports